import { render } from "./HeroCardHeader.vue?vue&type=template&id=bf0390e0&scoped=true"
import script from "./HeroCardHeader.vue?vue&type=script&lang=js"
export * from "./HeroCardHeader.vue?vue&type=script&lang=js"

import "./HeroCardHeader.vue?vue&type=style&index=0&id=bf0390e0&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0390e0"]])

export default __exports__